import axios from 'axios';
import {environment} from '../../config/environment';
import {getSessionTenantId, getToken, isValidSession} from './session';

const getStoredUser = () => {
    try {
        const rawUser = localStorage.getItem('userLogged');
        return rawUser ? JSON.parse(rawUser) : null;
    } catch {
        return null;
    }
};

const getCompanyId = (user) => (
    user?.companyId
    || user?.company_id
    || user?.company?.id
    || user?.empresa?.id
    || user?.context?.companyId
    || null
);

export const api = axios.create({
    baseURL: environment.apiBaseURLClients,
    headers: {
        'Content-Type': 'application/json',
    },
    timeout: 10000,
});

api.interceptors.request.use(
    (config) => {
        const userLogged = getStoredUser();
        const token = getToken(userLogged);

        if (token && isValidSession(userLogged)) {
            config.headers.Authorization = `Bearer ${token}`;
            // `tenantId`, e não `x-tenant-id`: o authorizer lê os dois, mas o identity, por
            // dentro, só lê este. Sem ele, todo USER leva 403 no identity.
            const tenantId = getSessionTenantId(userLogged);
            const companyId = getCompanyId(userLogged);
            if (tenantId) config.headers.tenantId = tenantId;
            if (companyId) config.headers.companyId = companyId;
            // O sistema do login, que é o do token. A API do backoffice resolve o sistema
            // dela, e não o do portal, então sem o cabeçalho o identity nega o cliente (BBF-110).
            if (environment.systemId) config.headers['x-system-id'] = environment.systemId;
        }

        return config;
    },
    (error) => Promise.reject(error)
);

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error?.response?.status === 401) {
            localStorage.removeItem('userLogged');
            if (window.location.pathname !== '/login') {
                window.location.href = '/login';
            }
        }

        return Promise.reject(error);
    }
);
